import { render, staticRenderFns } from "./EditFeedbackDialog.vue?vue&type=template&id=29753117&"
import script from "./EditFeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./EditFeedbackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports